import React from 'react';
import { Box, Grid, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';

import binaries from '../resource/binaries.svg';
import coding from '../resource/coding.svg';
import implement from '../resource/implement.svg';

const useStyles = makeStyles((theme) => ({
    logos: {
        height: '4em',
    },
    dummys: {
        height: '100vh'
    }
}));

const AboutUsBanner = () => {

    const classes = useStyles();
    const theme = useTheme();
    const matchesMD = useMediaQuery(theme.breakpoints.down('md'));
    const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
    const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));

    return (
        <Grid container direction={"column"} alignItems="center" style={{ marginBottom: '1em' }}>

            <Grid item >
                <Typography variant={matchesXS ? 'h6' : 'h4'} align="center">
                    <Box fontWeight={600} color={theme.palette.arenco.darkBlue} align="left">QUÉ HACEMOS</Box>
                </Typography>
            </Grid>

            <Grid item container direction="row" justify="space-between">
                <Grid item xs container direction="column" alignItems="center">
                    <Grid item>
                        <img className={classes.logos} src={coding} alt="image_coding"></img>
                    </Grid>
                    <Grid item>
                        <Box color={theme.palette.arenco.darkBlue} align="left">
                            <Typography variant="body2" align="center">
                                CREAMOS
                            </Typography></Box>
                    </Grid>
                </Grid>
                <Grid item xs container direction="column" alignItems="center">
                    <Grid item>
                        <img className={classes.logos} src={binaries} alt="image_binaries"></img>
                    </Grid>
                    <Grid item>
                        <Box fontWeight={400} color={theme.palette.arenco.darkBlue} align="left">
                            <Typography variant="body2">
                                TESTEAMOS</Typography></Box>
                    </Grid>
                </Grid>

                <Grid item xs container direction="column" alignItems="center">
                    <Grid item>
                        <img className={classes.logos} src={implement} alt="image_implementamos"></img>
                    </Grid>
                    <Grid item>
                        <Box fontWeight={400} color={theme.palette.arenco.darkBlue} align="left">
                            <Typography variant="body2">MANTENEMOS</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    );
};


export default AboutUsBanner;